import { changeoverTableColors } from 'common/pages/fleetV2/settings/aseptic';
import { fnt } from 'common/theme/standard.theme';
import styled from 'styled-components';
import { themeColors } from 'themes';

export const ProgrammedStepsContainer = styled.div`
  &.changeover-single-session--program-steps {
    border-width: 0 1px 1px 1px;
    border-style: solid;
    border-bottom-left-radius: 0.625rem;
    border-bottom-right-radius: 0.625rem;
    border-color: ${themeColors.mediumGrey1};
    font-size: ${fnt.md};

    .level-2 {
      background-color: ${themeColors.lightGrey1}; /* Apply blue background for 2nd level */
      color: ${themeColors.textLightBlack};
      border-top: 1px solid #dadada;
      td {
        padding: 0.5rem 0.6rem !important;
        width: max-content;
      }
      td.status {
        padding: 0.5rem 0.7rem !important;
      }
      div.parent-cell {
        font-weight: 400;
      }
      .alarms {
        color: ${themeColors.caution200};
        div {
          font-weight: 700;
          img {
            width: 15px;
          }
        }
      }
    }
    .status {
      img {
        width: 19px !important;
      }
    }
    // overwriting styles
    .customcss {
      display: none;
    }

    .disabled-sort {
      margin-left: 0;
    }

    .changeover-program-steps {
      padding: 0.5em 1.5em;
      display: block;

      .select-none {
        margin: 0;
      }

      .row-hasChildren {
        background: #f9fafb;

        .child-cell {
          padding-left: 2rem;
        }
      }

      .row td {
        padding: 0.75rem 0.625rem;
      }

      .target-diff {
        color: #b62c10;
        font-weight: 400;

        &.red {
          color: ${changeoverTableColors.negativeValue};
        }

        &.green {
          color: ${changeoverTableColors.positiveValue};
        }
      }

      tbody {
        tr {
          td:first-child {
            width: 20%;
          }

          td:nth-child(2) {
            width: 20%;
          }

          td:nth-child(3) {
            width: 20%;
          }

          td:nth-child(4) {
            width: 20%;
          }

          td:nth-child(4) {
            width: 20%;
          }
        }
      }

      thead {
        tr {
          th:nth-child(4) {
            padding: 0.5rem 0.6rem;
          }
          th:nth-child(5) {
            padding: 0.5rem 0.4rem;
          }
          th:nth-child(6) {
            padding: 0.5rem 0.5rem;
          }
        }
      }
      tbody td {
          padding: 0px 0.75rem;
      }
      tbody tr.open + .row-hasChildren {
        box-shadow: inset 0px 5px 5px 0px #e9e9e9;
      }
      tbody tr:last-child td {
        border-bottom: 0;
      }

      tbody tr td:first-child {
        padding-left: 0;
        padding-right: 0;
      }

      tr td span {
        margin-left: 0;
        div {
          font-weight: bold;
        }
      }

      .cell-status {
        display: flex;
        align-items: center;
        font-weight: normal;

        img {
          width: 15px;
        }

        .button-issues {
          background: none;
          border: 0;
          cursor: pointer;
        }
      }

      .parent-cell {
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 0.9rem;
      }

      .child-cell {
        display: flex;
        align-items: center;
        font-weight: 400;
      }

      .button-expand {
        background: none;
        border: 0;
      }
    }
  }
`;

export const ProgrammedNestedStepsContainer = styled.div`
  &.changeover-single-session--program-stepsnested {
    img {
      width: 19px;
    }
    tbody tr td {
      border-bottom: 0;
    }
    .nested-row {
      background: ${themeColors.lightGrey10};
      box-shadow: rgb(242, 243, 244 / 38%) 0px 5px 5px 0px;

      tfoot {
        display: none;
      }
      thead {
        background: ${themeColors.lightGrey10};
      }
      padding: 0em 1.5em 0em 1.5em;
      margin-bottom: 0px;

      .select-none {
        margin: 0;
      }

      .row-hasChildren {
        background: ${themeColors.lightGrey10};
        border-top: 0.0625rem solid #dadada;

        td.id {
          padding: 0.5rem 0.9rem;
          width: max-content;
        }
        span.text-bold {
          font-weight: 700;
          color: #666666;
        }
      }

      .row td {
        padding: 0.75rem 0.625rem;
      }

      .target-diff {
        color: ${themeColors.darkRed3};
        font-weight: 400;

        &.red {
          color: ${changeoverTableColors.negativeValue};
        }

        &.green {
          color: ${changeoverTableColors.positiveValue};
        }
      }

      tbody {
        tr {
          td:first-child {
            width: 20%;
            padding-left: 7.875rem;
          }

          td:nth-child(2) {
            width: 20%;
            padding-left: 0rem;
            margin-left: -3px;
          }

          td:nth-child(3) {
            width: 20%;
            padding-left: 0.4rem;
          }

          td:nth-child(4) {
            width: 20%;
            padding-left: 0.9rem;
          }
          td:nth-child(5) {
            padding: 0rem 0rem;
          }
        }
      }

      thead {
        tr {
          th:first-child {
            width: 20%;
            padding-left: 0.938rem;
          }

          th:nth-child(2) {
            width: 20%;
            padding: 0.5rem 0rem;
          }

          th:nth-child(3) {
            width: 20%;
            padding: 0.5rem 0.6rem;
          }

          th:nth-child(4) {
            width: 21.7%;
            padding: 0.5rem 0.9rem;
          }
          th:nth-child(5) {
            width: 10%;
            padding: 0.5rem 0rem;
          }
          th:nth-child(6) {
            padding: 0.5rem 0rem;
          }
        }
      }

      tbody tr.open + .row-hasChildren {
        box-shadow: inset 0px 5px 5px 0px #e9e9e9;
      }

      tbody tr:last-child td {
        border-bottom: 0;
      }

      tbody tr td:first-child {
        padding-left: 0;
      }

      tr td span {
        margin-left: 0;
        div {
          font-weight: bold;
        }
      }
      }
    }
  }
`;
